/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { onboardingRevokeInvite } from "../../funcs/onboardingRevokeInvite.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RevokeOnboardingInviteRequest$inboundSchema,
};

export const tool$onboardingRevokeInvite: ToolDefinition<typeof args> = {
  name: "onboarding-revoke-invite",
  description:
    `Revoke an onboarding invite, rendering the invitation link unusable.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await onboardingRevokeInvite(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
